import React from "react";
import { Box, Card, Chip, Divider, FormControlLabel, Radio, Stack, Typography } from "@mui/material";
import { CheckCircle as CheckIcon } from "@mui/icons-material";

export function PlanCard({ value, selected, title, price, badge, vatLabel, helper }) {
    return (
        <Box
            component={FormControlLabel}
            value={value}
            control={<Radio sx={{ display: "none" }} />}
            label={
                <Card
                    variant={selected ? "elevation" : "outlined"}
                    elevation={selected ? 2 : 0}
                    sx={{
                        borderRadius: 2,
                        px: 2,
                        py: 1.5,
                        minWidth: 220,
                        width: "100%",
                        cursor: "pointer",
                        borderColor: selected ? "warning.light" : "divider",
                        background: selected ? "rgba(255,165,0,0.06)" : "transparent",
                        transition: "all .15s ease",
                        "&:hover": { boxShadow: "0 8px 24px rgba(0,0,0,0.06)" },
                    }}
                >
                    <Stack direction="row" alignItems="flex-start" justifyContent="space-between" gap={1}>
                        <Box>
                            <Typography variant="subtitle1" fontWeight={700}>
                                {title}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {vatLabel}
                            </Typography>
                        </Box>
                        <Stack spacing={0.25} alignItems="flex-end">
                            <Typography variant="h6" fontWeight={800}>
                                {price}
                            </Typography>
                            {helper && (
                                <Typography variant="caption" color="text.secondary">
                                    {helper}
                                </Typography>
                            )}
                        </Stack>
                    </Stack>
                    {badge && <Box sx={{ mt: 1 }}>{badge}</Box>}
                </Card>
            }
            sx={{ m: 0, flex: "1 1 240px" }}
        />
    );
}

export function TierCard({ value, selected, title, price, subtitle, features, highlight }) {
    return (
        <Box
            component={FormControlLabel}
            value={value}
            control={<Radio sx={{ display: "none" }} />}
            label={
                <Card
                    variant={selected ? "elevation" : "outlined"}
                    elevation={selected ? 3 : 0}
                    sx={{
                        borderRadius: 2,
                        p: 2,
                        minWidth: 260,
                        width: "100%",
                        borderColor: selected ? "warning.light" : "divider",
                        background: selected ? "rgba(255,165,0,0.06)" : "background.paper",
                        cursor: "pointer",
                        transition: "all .15s ease",
                        "&:hover": { boxShadow: "0 10px 26px rgba(0,0,0,0.08)" },
                    }}
                >
                    <Stack spacing={1.5}>
                        <Stack direction="row" alignItems="flex-start" justifyContent="space-between" gap={1}>
                            <Box>
                                <Typography variant="subtitle1" fontWeight={700}>
                                    {title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {subtitle}
                                </Typography>
                            </Box>
                            {highlight && <Chip size="small" color="warning" label="Beliebt" variant="outlined" />}
                        </Stack>
                        <Typography variant="h6" fontWeight={800}>
                            {price}
                        </Typography>
                        <Divider />
                        <Stack spacing={1}>
                            {features.map((feature) => (
                                <Stack key={feature} direction="row" alignItems="center" gap={1}>
                                    <CheckIcon fontSize="small" sx={{ color: "orange" }} />
                                    <Typography variant="body2">{feature}</Typography>
                                </Stack>
                            ))}
                        </Stack>
                    </Stack>
                </Card>
            }
            sx={{ m: 0, flex: "1 1 260px", maxWidth: 360 }}
        />
    );
}
